export enum TabName {
    company = "company",
    signals = "signals",
    companyStructure = "companyStructure",
}

export type TabBehaviorConfig = {
    isIntersectionTrackingSupported: boolean;
    onIntersection?(tabName: string): void;
};
